import React, { useCallback } from 'react';

const BulletinMatiereTable = ({ bulletin, matieres }) => {
	// Get notes for a specific bulletin and matiere
	const getNotesForBulletinAndMatiere = useCallback(
		(bulletinEvaluationId, matiereId) => {
			if (bulletin && bulletin.bulletins_evaluation) {
				const evaluation = bulletin.bulletins_evaluation.find(
					(bulletinEval) => bulletinEval.id === bulletinEvaluationId
				);
				if (evaluation) {
					return evaluation.notes_evaluations.find(
						(note) => note.matiere === matiereId
					);
				}
			}
			return null; // Return null if no notes are found or if the arrays are empty
		},
		[bulletin]
	);

	const getAverageForBulletinAndMatiere = useCallback(
		(notesTrimestrielles, bulletinId, matiereId) => {
			// Rechercher la note trimestrielle correspondante
			const noteTrimestrielle = notesTrimestrielles.find(
				(note) =>
					note.bulletin_trimestriel === bulletinId && note.matiere === matiereId
			);

			// Retourner la note trouvée ou null si non trouvée
			if (noteTrimestrielle) {
				return {
					note_total: noteTrimestrielle.note_total
						? noteTrimestrielle.note_total.toFixed(2)
						: 0,
					note_matiere: noteTrimestrielle.note_matiere
						? noteTrimestrielle.note_matiere.toFixed(2)
						: 0,
					grade: noteTrimestrielle.grade
				};
			}
			return null;
		},
		[]
	);

	const addSuffixToRank = (rank, section) => {
		if (!rank || typeof rank !== 'number') {
			return '';
		}

		if (section === 'fr') {
			// Pour la section française
			if (rank === 1) {
				return `${rank}er`;
			} else {
				return `${rank}e`;
			}
		} else {
			// Pour d'autres sections (par exemple, anglaise)
			const suffixes = ['th', 'st', 'nd', 'rd'];
			const value = rank % 100;
			return `${rank}${
				suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0]
			}`;
		}
	};

	return (
		<div>
			{bulletin && matieres && matieres.length > 0 ? (
				<>
					<table className="table table-sm table-light table-bordered">
						<thead>
							<tr className="align-middle">
								<th
									className="text-uppercase align-middle fw-bold"
									style={{ width: '50%', color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'MATIERES'
										: 'SUBJECTS'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'NOTES'
										: 'MARKS'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'CI/TL-1'
										: 'M1'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'CI/TL-2'
										: 'M2'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'CI/TL-3'
										: 'M3'}
								</th>
								<th
									className="text-center text-uppercase align-middle fw-bold"
									style={{ color: 'black' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moy. Gle'
										: 'Overall Avg'}
								</th>
							</tr>
						</thead>
						<tbody>
							{matieres.map(
								(matiere) =>
									matiere && (
										<React.Fragment key={matiere.id}>
											<tr>
												<td className="text-uppercase align-middle">
													{matiere.nom}
												</td>
												<td className="text-uppercase align-middle text-center">
													{matiere[
														`points_${bulletin.salledeclasse_details.id}`
													] || 0}
												</td>
												{bulletin.bulletins_evaluation
													.sort((a, b) => a.examen - b.examen)
													.map((bulletin_evaluation, index) => {
														const notes = bulletin
															? getNotesForBulletinAndMatiere(
																	bulletin_evaluation.id,
																	matiere.id
															  )
															: null;
														return (
															<td
																className="text-center"
																key={
																	bulletin_evaluation
																		? bulletin_evaluation.id
																		: index
																}
															>
																{notes ? notes.note_matiere : ''}
															</td>
														);
													})}
												{Array.from({
													length: 3 - bulletin.bulletins_evaluation.length
												}).map((_, index) => (
													<td
														className="text-center"
														key={`empty-${index}`}
													></td>
												))}
												<td className="text-center">
													{bulletin.notes_trimestrielles &&
														(() => {
															const notes = getAverageForBulletinAndMatiere(
																bulletin.notes_trimestrielles,
																bulletin.id,
																matiere.id
															);

															return notes ? notes.note_matiere : 0;
														})()}
												</td>
											</tr>
										</React.Fragment>
									)
							)}
							<tr>
								<td className="text-uppercase align-middle fw-bold">TOTAL</td>
								<td className="text-uppercase align-middle fw-bold text-center">
									{bulletin.total_points_trimestriel !== null &&
									bulletin.total_points_trimestriel !== undefined
										? bulletin.total_points_trimestriel
										: ''}
								</td>
								{bulletin.bulletins_evaluation
									.sort((a, b) => a.examen - b.examen)
									.map((bulletin_evaluation, index) => {
										return (
											<td
												className="text-center"
												key={
													bulletin_evaluation ? bulletin_evaluation.id : index
												}
											>
												{bulletin_evaluation.total_obtenu !== null &&
												bulletin_evaluation.total_obtenu !== undefined
													? bulletin_evaluation.total_obtenu.toFixed(2)
													: ''}
											</td>
										);
									})}
								{Array.from({
									length: 3 - bulletin.bulletins_evaluation.length
								}).map((_, index) => (
									<td className="text-center" key={`empty-${index}`}></td>
								))}

								<td className="text-center">
									{bulletin.total_obtenu !== null &&
									bulletin.total_obtenu !== undefined
										? bulletin.total_obtenu.toFixed(2)
										: ''}
								</td>
							</tr>
							<tr>
								<td className="text-uppercase align-middle fw-bold">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'MOYENNE'
										: 'AVERAGE'}
								</td>
								<td className="text-uppercase align-middle fw-bold text-center">
									20
								</td>
								{bulletin.bulletins_evaluation
									.sort((a, b) => a.examen - b.examen)
									.map((bulletin_evaluation, index) => {
										return (
											<td
												className="text-center"
												key={
													bulletin_evaluation ? bulletin_evaluation.id : index
												}
											>
												{bulletin_evaluation.moyenne_generale !== null &&
												bulletin_evaluation.moyenne_generale !== undefined
													? bulletin_evaluation.moyenne_generale.toFixed(2)
													: ''}
											</td>
										);
									})}
								{Array.from({
									length: 3 - bulletin.bulletins_evaluation.length
								}).map((_, index) => (
									<td className="text-center" key={`empty-${index}`}></td>
								))}

								<td className="text-center">
									{bulletin.moyenne_generale !== null &&
									bulletin.moyenne_generale !== undefined
										? bulletin.moyenne_generale.toFixed(2)
										: ''}
								</td>
							</tr>
							<tr>
								<td className="text-uppercase align-middle fw-bold">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'RANG'
										: 'POSITION'}
								</td>
								<td style={{ backgroundColor: '#000000' }}></td>
								{bulletin.bulletins_evaluation
									.sort((a, b) => a.examen - b.examen)
									.map((bulletin_evaluation, index) => {
										return (
											<td
												className="text-center"
												key={
													bulletin_evaluation ? bulletin_evaluation.id : index
												}
											>
												{bulletin_evaluation.rang !== null &&
												bulletin_evaluation.rang !== undefined
													? addSuffixToRank(
															bulletin_evaluation.rang,
															bulletin.salledeclasse_details.section
													  )
													: ''}
											</td>
										);
									})}
								{Array.from({
									length: 3 - bulletin.bulletins_evaluation.length
								}).map((_, index) => (
									<td className="text-center" key={`empty-${index}`}></td>
								))}

								<td className="text-center">
									{bulletin.rang !== null && bulletin.rang !== undefined
										? addSuffixToRank(
												bulletin.rang,
												bulletin.salledeclasse_details.section
										  )
										: ''}
								</td>
							</tr>
						</tbody>
					</table>

					<table className="table table-sm table-light table-bordered mt-4">
						<thead>
							<tr className="align-middle">
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'DISCIPLINE'
										: 'SUBJECT'}
								</th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Absences'
										: 'Abscences'}
								</th>
								<th style={{ width: '50px' }}></th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Heures justifiées'
										: 'Justified Hours'}
								</th>
								<th style={{ width: '50px' }}></th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Heures non justifiées'
										: 'Unjustified Hours'}
								</th>
								<th style={{ width: '50px' }}></th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Jours suspension'
										: 'Suspension Days'}
								</th>
								<th style={{ width: '50px' }}></th>
							</tr>
							<tr className="align-middle">
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'STATS DE PERFORMANCES'
										: 'PERFORMANCE STATS'}
								</th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moyenne Premier'
										: 'First Average'}
								</th>
								<th style={{ width: '50px' }} className="text-center">
									{bulletin.moyenne_premier !== null &&
									bulletin.moyenne_premier !== undefined
										? bulletin.moyenne_premier.toFixed(2)
										: ''}
								</th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moyenne Dernier'
										: 'Last Average'}
								</th>
								<th style={{ width: '50px' }} className="text-center">
									{bulletin.moyenne_dernier !== null &&
									bulletin.moyenne_dernier !== undefined
										? bulletin.moyenne_dernier.toFixed(2)
										: ''}
								</th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Moyenne Classe'
										: 'Class Average'}
								</th>
								<th style={{ width: '50px' }} className="text-center">
									{bulletin.moyenne_classe !== null &&
									bulletin.moyenne_classe !== undefined
										? bulletin.moyenne_classe.toFixed(2)
										: ''}
								</th>
								<th>
									{bulletin.salledeclasse_details.section === 'fr'
										? '% Réussite'
										: '% Success'}
								</th>
								<th style={{ width: '50px' }} className="text-center">
									{bulletin.pourcentage_reussite !== null &&
									bulletin.pourcentage_reussite !== undefined
										? bulletin.pourcentage_reussite.toFixed(2)
										: ''}
									%
								</th>
							</tr>
						</thead>
						<tbody>
							<tr className="align-middle">
								<th
									colSpan="9"
									className="text-center text-dark fw-bold"
									style={{ backgroundColor: '#b1b1b1' }}
								>
									{bulletin.salledeclasse_details.section === 'fr'
										? 'OBSERVATION'
										: 'OBSERVATION'}
								</th>
							</tr>
							<tr className="align-middle">
								<th colSpan="2">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Observations du titulaire'
										: "Teacher's Remarks"}
								</th>
								<th colSpan="2">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Observations disciplinaires'
										: 'Appreciations'}
								</th>
								<th colSpan="2">
									{bulletin.salledeclasse_details.section === 'fr'
										? 'Signature des parents'
										: "Parent's Signature"}
								</th>
								<th colSpan="3">
									{bulletin.salledeclasse_details.section === 'fr'
										? "Signature du chef de l'établissement"
										: "Headteacher's Signature"}
								</th>
							</tr>
							<tr>
								<td colSpan="2" style={{ height: '120px' }}></td>
								<td colSpan="2" style={{ height: '120px' }}></td>
								<td colSpan="2" style={{ height: '120px' }}></td>
								<td colSpan="3" style={{ height: '120px' }}></td>
							</tr>
						</tbody>
					</table>
				</>
			) : (
				<div>
					Chargement des notes de l'élève pour le bulletin trimestriel (Bulletin
					Matieres)...
				</div>
			)}
		</div>
	);
};

export default BulletinMatiereTable;
